import { createContext } from "react";

import { FeatureFlags } from "@/types";

type FeaturesContext = { featureFlags?: FeatureFlags };

export const FeaturesContext = createContext<FeaturesContext>({});
